import { User } from '../types';
import { loadViewAs } from './loadViewAs';

export function getCurrentCompanyId(user?: User) {
  return user?.role.startsWith('company') ? user.companyId : loadViewAs();
}
